export const VERSION_INFO = {
  "version": "13.9.5",
  "build": 1295,
  "lastCommit": "a74b2f9",
  "buildDate": "2026-10-28T19:42:51.991Z"
};